@if (packageWithTv() && 'MOBILE_ONLY' !== type()) {
  <div class="grid gap-4">
    <webmodule-order-panel (showContentChange)="showSelected.set($event)"
                           [canCollapse]="isLoaded()"
                           [showContent]="showSelected()">
      <ng-container heading>
        <h3 class="mb-0" [innerHTML]="index() + '. ' + ('block.television.heading' | translate) "></h3>
      </ng-container>
      <ng-container content>

        @if (isLoaded()) {
          <div [innerHtml]="'block.television.description' | translate" class="wysiwyg"></div>

          @if(hasTranslationForKey('block.television.more-information')) {
            <div><button (click)="openModal('block.television.heading', 'block.television.more-information')" class="btn link">{{ 'common.button.more-info' | translate }}</button></div>
          }
        } @else {
          <webmodule-order-skeleton-screen [pulse]="isLoading()" type="TEXT_BLOCK" />
        }

        @if (isLoaded()) {
          <fieldset>
            <legend class="sr-only">{{ 'block.television.tv.title' | translate }}</legend>
            <div class="grid gap-4 py-4">
              <h4>{{ 'block.television.tv.title' | translate }}</h4>
              <div [innerHtml]="'block.television.tv.description' | translate"></div>
              @if(hasTranslationForKey('block.television.tv.more-information')) {
                <div><button (click)="openModal('block.television.tv.title', 'block.television.tv.more-information')" class="btn link">{{ 'common.button.more-info' | translate }}</button></div>
              }
              @for (item of itvBoxType; track item) {
                <webmodule-order-input-panel [checked]="item.id === selectItvBoxType()"
                                             [priceAlt]="item.id === 'withItvBox' ? '1e box inbegrepen' : ''"
                                             [ref]="item.id"
                                             (selected)="setType(item)"
                                             groupName="tvType">
                  <ng-container label>{{ item.name }}</ng-container>
                </webmodule-order-input-panel>
              }
            </div>
          </fieldset>
          @if ('withItvBox' === selectItvBoxType()) {
            @if (tvBoxOption(); as tvBoxOption) {
              <fieldset>
                <legend class="sr-only">{{ 'block.television.tv-boxes.title' | translate }}</legend>
                <div class="grid gap-4 py-4">
                  <h4>{{ 'block.television.tv-boxes.title' | translate }}</h4>

                  @if(hasTranslationForKey('block.television.tv-boxes.more-information')) {
                    <div><button (click)="openModal('block.television.tv-boxes.title', 'block.television.tv-boxes.more-information')" class="btn link">{{ 'common.button.more-info' | translate }}</button></div>
                  }
                  @for (item of [].constructor(3); track item; let index = $index) {
                    <webmodule-order-input-panel [checked]="isTvBoxSelected(index, tvBoxOption.value)"
                                                 [price]="index * tvBoxOption.price"
                                                 [discount]="getTvBoxDiscount(tvBoxOption.id, index)"
                                                 [ref]="index"
                                                 (selected)="setBoxes($event)"
                                                 groupName="tvBoxes">
                      <ng-container label>{{ 'block.television.input.tv-boxes.label' | translate: {tvBoxes:index + 1 } }}</ng-container>
                    </webmodule-order-input-panel>
                  }
                </div>
              </fieldset>
            }
          }
        }
      </ng-container>
      @if (isLoaded()) {
        <ng-container altContent>
          @if (getSelectedType(); as selected) {
            <div class="grid grid-cols-2 border-t pt-4">
              <div class="h5 mb-0">{{ selected.name }}</div>
              <div class="h5 mb-0 text-right row-span-2">
                @if (selectBoxes() !== null) {
                  @if (getSelectedBoxes() >= 0) {
                    {{ getSelectedBoxes() > 0 ? (getSelectedBoxes() * tvBoxUnitPrice() | currency:'EUR') + '/maand' : '' }}
                  }
                }
              </div>


              @if (getSelectedType(); as selected) {
                @if (selectBoxes() !== null) {
                  @if (getSelectedBoxes() >= 0) {
                    <div class="col-span-2">{{ getSelectedBoxes() + 1 }} Interactive TV {{ getSelectedBoxes() >= 1 ? 'boxen' : 'box' }} en de TV App</div>
                  }
                }
              }
            </div>
          }

        </ng-container>
      }
      <ng-container footer></ng-container>
    </webmodule-order-panel>
    @if ('withItv' === select()?.id) {
      <webmodule-order-panel (showContentChange)="showSelected.set($event)"
                             [canCollapse]="true">
        <ng-container heading>
          <h3 class="mb-0">{{ index() + 1 }}. {{ 'block.television.extra-tv.heading' | translate }}</h3>
        </ng-container>
        <ng-container content>
          <fieldset>
            <legend class="sr-only">{{ 'block.television.extra-tv.heading' | translate }}</legend>
            <div class="grid gap-4">
              @if (isLoaded()) {
                @for (item of tvExtraOptions(); track item) {
                  <webmodule-order-input-panel (selected)="setPackageState(item)"
                                               [checked]="isTvOptionsSelected(item.id)"
                                               [disabled]="item.isPartOfPackage"
                                               [price]="item.price"
                                               [isPartOfPackage]="item.isPartOfPackage"
                                               [discount]="getDiscountById(item.id)"
                                               [ref]="item.id"
                                               inputType="checkbox"
                                               groupName="tvOptions">
                    <ng-container label>{{ item.name }}</ng-container>
                    <ng-container content>
                      @if (item.description) {
                        <span [innerHTML]="item.description"
                              class="mt-1 text-sm col-span-auto text-gray-500 whitespace-pre-line col-span-2">
                        </span>

                        @if (item.imageUrl) {
                          <img src="{{ item.imageUrl }}" class="py-2 self-center text-right" [alt]="item.label"/>
                        }
                      }
                    </ng-container>
                  </webmodule-order-input-panel>
                }
              } @else {
                <webmodule-order-skeleton-screen [pulse]="isLoading()"></webmodule-order-skeleton-screen>
                <webmodule-order-skeleton-screen [pulse]="isLoading()"></webmodule-order-skeleton-screen>
              }
            </div>
          </fieldset>
        </ng-container>
        @if (isLoaded()) {
          <ng-container altContent>
            @for (tvOption of selectedTvOptions(); track tvOption) {
              <div class="grid grid-cols-2 mb-2">
                <div class="h5 mb-0">{{ tvOption.name }}</div>
                <div class="h5 mb-0 text-right">
                  {{ tvOption.isPartOfPackage ? 'Inbegrepen' : (tvOption.price | currency:'EUR') + '/maand' }}
                </div>
              </div>
            }
          </ng-container>
        }
        <ng-container footer></ng-container>
      </webmodule-order-panel>
    }
  </div>
}
